export const eDirection = {
    LEFT: "left",
    RIGHT: "right",
    UP: "up",
    DOWN: "down",
    IN: "in",
    OUT: "out",
    RESET: "reset",
};

export const eSearchLogic = {
    BEGINS: "begins",
    CONTAINS: "contains",
};

export const eSearchFilter = {
    PICTURE: "Stitle",
    SOUND: "Ssound",
    PHONETIC: "Sphon",
};

export const eMode = {
    USER_SIGN_IN: "mode-user-sign-IN",
    USER_REGISTER: "mode-user-register",
    USER_OPTIONS: "mode-user-options",
    USER_ACTIVE: "mode-user-active",
    USER_PENDING: "mode-user-pending",

    NEW_PROJECT: "mode-new-project",
    OPEN_PROJECT: "mode-open-project",
    SAVE_PROJECT: "mode-save-project",
    SAVE_BEFORE_NEW: "mode-save-before-new",
    PRINT_PROJECT: "mode-print-project",
    ADD_IMAGE: "mode-add-image",
    EDIT_IMAGE: "mode-edit-image",
    CHOOSE_TEMPLATE: "mode-choose-template",
    EDIT_TEMPLATE: "mode-edit-template",
    ADD_TEXT: "mode-add-text",
    EDIT_TEXT: "mode-edit-text",
    COLOUR_IMAGE: "mode-colour-image",
    COLOUR_TEXT: "mode-colour-text",
    MY_ACCOUNT: "mode-my-account",
    CONFIRM_DELETE: "mode-confirm-delete",
    CONFIRM_NEW: "mode-confirm-new",
    SET_ORIENTATION: "mode-set-orientation",

    APP_UPDATING: "mode-app-updating",
};
